export const previewImage = ({ file, cb }) => {
    const oFReader = new FileReader();
    if (file) {
        oFReader.readAsDataURL(file);
        oFReader.onload = function (oFREvent) {
            if (cb) {
                cb(oFREvent.target.result);
            }
        };
    }
};

export const camelToSnakeCase = (key) => {
    let result = key.replace( /([A-Z])/g, " $1" );
    return result.split(' ').join('_').toLowerCase();
};

export const snakeToCamelCase = (str) => {
    return str.replace(
        /(?!^)_(.)/g,
        (_, char) => char.toUpperCase()
    );
}

export const numberToLetter = (i) => String.fromCharCode(64 + i);

export const notNullOrUndefinedCheck = (value, defaultValue) => {
    if (value !== null && value !== undefined) {
        return value;
    } else {
        return defaultValue;
    }
};
